import React from 'react';
import {Typography, useMediaQuery, useTheme} from "@mui/material";

function TopTitle(props) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    return (
        <Typography variant={isMobile?"h4":"h2"} {...props}>{props.children}</Typography>
    );
}

export default TopTitle;